import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { colors, Button, Tag, Typography } from '@sweep-io/sweep-design';
import pluralize from 'pluralize';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../../reducers/userInfoReducer';
import { selectAgents } from '../../../aiAgentCenter/agentsSelectors';
import { getTotalIssues } from './getTotalIssues';
import { AgentType } from '@server/ai';

export const MonitoringAgentsButton = ({
  openMonitoringPopover,
}: {
  openMonitoringPopover: () => void;
}) => {
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const agents = useSelector(selectAgents(crmOrgId ?? undefined));
  const monitoringAgents = agents?.filter((agent) => agent.type === AgentType.MonitoringV2) ?? [];
  const agentsCount = monitoringAgents.length;
  const totalIssues = getTotalIssues(monitoringAgents);

  return (
    <Button variant="flat-grey" size="small" onClick={openMonitoringPopover}>
      <Stack direction="row" alignItems="center" gap="8px">
        <Box sx={{ textDecoration: 'underline' }}>
          <Typography variant="caption-medium" color={colors.grey[700]}>
            Monitoring
          </Typography>
          {agentsCount > 0 && (
            <Typography variant="caption" color={colors.grey[700]}>
              {` ${pluralize('Agent', agentsCount, true)}`}
            </Typography>
          )}
        </Box>
        <Tag
          size="small"
          color={colors.seafoam[300]}
          label={agentsCount > 0 ? pluralize('issue', totalIssues, true) : 'Resolve Tech Debt'}
        />
      </Stack>
    </Button>
  );
};
